import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { User } from 'src/app/models/user.model';
import { CoreService } from 'src/app/services/core.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [NgIf],
  template: `
    <div class="branding">
      @if(options.theme === 'light') {
      <a href="/home">
        <img
          [src]="logoSrc"
          class="align-middle m-l-0 logo-img"
          alt="logo"
        />
      </a>
      } @if(options.theme === 'dark') {
      <a href="/home">
        <img
          [src]="logoSrc"
          class="align-middle m-l-0 logo-img"
          alt="logo"
        />
      </a>
      }
    </div>
  `,
  styles: [`
    .logo-img {
      width: 100%;
      max-width: 240px;
      height: auto;
      transition: all 0.2s ease-in-out;
    }
  `]
})
export class BrandingComponent {
  options = this.settings.getOptions();
  user: User
  logoSrc: string

  constructor(private settings: CoreService,
    private userService: UserService
  ) {

    this.user = this.userService.user

    this.applyUserAppearance()
  }

  applyUserAppearance() {
    const hostname = window.location.hostname

    if (this.user?.appearance?.logo) {
      this.logoSrc = this.user.appearance.logo;
    } else if (hostname === 'innosolutions.wikyapps.com') {
      this.logoSrc = 'assets/images/logos/innosolutions.png';
    } else {
      this.logoSrc = 'assets/images/logos/hpdm_logo.png';
    }

    localStorage.setItem('userAppearance', JSON.stringify(this.options));
  }
}
